module.exports = __webpack_public_path__ + "static/13-79f09580f210808eade8e971421056f6.jpg";